<div class="card border-0 shadow">
  <div class="card-body">
    <div *ngIf="showLogin" class="row">
      <div>
        <div class="mb-4">
          <img class="bidit-logo" alt="BiditWeb" src="assets/img/Bidit_Logo.png" />
          <p class="login-header col-8">Welcome to IDI's BIDIT <br />Contractor Resource Tool</p>
        </div>
        <p class="text-bidit-primary col-10">Now you can leverage decades of experience from IDI in helping partners grow their business</p>
      </div>
      <div class="col-12">
        <h6>Log In</h6>
        <form #f="ngForm" novalidate (ngSubmit)="login(f)">
          <div class="form-group">
            <label for="email">EMAIL ADDRESS</label>
            <input id="email" type="text" required name="email" [ngModel]="credentials.email" #email="ngModel" tmFocus validateEmail class="form-control"
                   placeholder="Email Address">

            <small [hidden]="email.valid || (email.pristine && !submitted)" class="text-danger">
              Please enter a valid email
            </small>
          </div>
          <div class="form-group">
            <label for="password">PASSWORD</label>
            <input id="password" type="password" required name="password" class="form-control" placeholder="Password" ngModel>
          </div>
          <div class="form-group float-right">
            <a class="text-bidit-primary float-right" [routerLink]="[]" (click)="forgotPassword()">Forgot Password?</a>
          </div>
          <div class="col-12 form-group float-right">
            <button type="submit" class="row btn btn-bidit-action float-right" [disabled]="f.invalid || isRequesting">Login</button>
          </div>
          <app-spinner [isRunning]="isRequesting"></app-spinner>
          <div *ngIf="errors" class="row alert alert-danger" role="alert">
            <strong>errors</strong>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="showForgotPassword">
      <div class="d-flex flex-column">
        <div class="row justify-content-center">
          <img class="bidit-logo-center" alt="BiditWeb" src="assets/img/Bidit_Logo.png" />
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <p class="text-bidit-primary-header">Forget Your Password?</p>
            <p class="warning bold">No Problem! Type in your email address and we'll send you a link to change it.</p>

            <form #fp="ngForm" novalidate (ngSubmit)="sendPasswordReset(fp)">
              <div class="form-group">
                <input id="email" type="email" required name="email" [ngModel]="credentials.email" #email="ngModel" email="true" class="form-control"
                       placeholder="e-mail">

                <small [hidden]="email.valid" class="text-danger">
                  Please enter a valid email
                </small>
              </div>

              <div class="row form-group float-right">
                <div class="col-sm-12">
                  <div class="float-right">
                    <app-spinner [isRunning]="isRequesting"></app-spinner>
                    <button type="submit" class="mr-3 btn btn-bidit-action" [disabled]="fp.invalid || isRequesting">Submit</button>
                    <button type="button" class="btn btn-bidit-action" (click)="returnToLogin()">Cancel</button>
                  </div>
                </div>
              </div>
              <div *ngIf="errors" class="row alert alert-danger" role="alert">
                <strong>Unable to Reset Password</strong> {{errors}}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
